// Mirrors sonner's internal TOAST_LIFETIME. The <Toaster> in app/layout.tsx sets no
// duration, so this is what every toast actually gets. Keep both in sync — the toast
// progress indicator animates for exactly this long.
export const APP_TOAST_DURATION_MS = 4000;
